<script lang="ts">
  import { format } from "date-fns";
  import { TypographyType } from "../../lib/constants/typographyMap";
  import Typography from "../Typography.svelte";
  import type { OrderEvent } from "../../types/orderEvent";

  export let latestTrackingEvent: OrderEvent;

  const getDeliveryState = (status: string) => status?.replace(/-/g, " ");

  const getDeliveryIndicatorState = (status: string): Array<string> => {
    const indicators = Array.from({length: 4}, () => "--color-grayscale-30");

    switch (status) {
      case "pending":
        return indicators.fill("--color-green-20", 0, 1);

      case "picking-up":
      case "picked-up":
        return indicators.fill("--color-green-20", 0, 2);

      case "delivering":
        return indicators.fill("--color-green-20", 0, 3);

      case "delivered":
        return indicators.fill("--color-green-20");

      case "cancelled":
        return indicators.fill("--color-red-20");

      default:
        return indicators;
    }
  };

  const getFormattedDate = (dateString: string) => {
    return format(new Date(dateString), "EEEE',' MM/dd/yyyy 'until' p");
  };
</script>

<div aria-label="progress-status-bar">
  <div class="capitalize w-1/2 text-left">
    <Typography
      mobile={TypographyType.Headline3}
      desktop={TypographyType.Headline1}
      copy={getDeliveryState(latestTrackingEvent?.status)}
    />
  </div>
  <div class="my-4 flex gap-1">
    {#each getDeliveryIndicatorState(latestTrackingEvent?.status) as state}
      <span style="background-color: var({state})" class="w-1/4 h-2 bg-[color:var({state})] first:rounded-l-xl last:rounded-r-xl" />
    {/each}
  </div>
  {#if latestTrackingEvent?.estimated_delivered_at}
    <div>
      <Typography
        mobile={TypographyType.Body2Regular}
        desktop={TypographyType.Body2Medium}
        copy={"Estimated delivery time"}
        --font-color="var(--color-grayscale-90)"
      />
      <Typography mobile={TypographyType.Body1Medium} desktop={TypographyType.Headline5Medium}>
        {getFormattedDate(latestTrackingEvent?.estimated_delivered_at)}
      </Typography>
    </div>
  {/if}
</div>

<style>
</style>
